/**
 * TwoFactorGuard — currently a passthrough.
 *
 * Replit-managed Clerk does not support MFA/2FA, so this component
 * cannot gate access based on two-factor status. It renders children
 * unconditionally. The informational note about 2FA availability is
 * surfaced in Settings → Compliance & Security instead.
 *
 * If the project migrates to a self-managed Clerk instance that supports
 * TOTP/SMS MFA, the enforcement logic can be restored here.
 */
export function TwoFactorGuard({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
